import React from 'react';
import UpdateEmail from 'pages/counselor/account/UpdateEmailAccount';

const ProfileUpdateEmail = () => {
    return <UpdateEmail />;
};

export default ProfileUpdateEmail;
